import {commitLocalUpdate} from 'relay-runtime'



import EndDraggingReflectionMutation from '../../mutations/EndDraggingReflectionMutation'

const handleDrop = (
  atmosphere,
  reflectionId,
  drag,
  dropTargetType,
  dropTargetId
) => {
  commitLocalUpdate(atmosphere, (store) => {
    store.get(reflectionId).setValue(true, 'isDropping')
  })

  EndDraggingReflectionMutation(atmosphere, {
    reflectionId,
    dropTargetType,
    dropTargetId,
    dragId: drag.id
  })
}

export default handleDrop
